import ModalidadeService from '../_services/ModalidadeService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { modalidadeModel } from '../_model/modalidade'

const state = {
  loading: false,
  loadingStore: false,
  modalidades: [],
  currentPage: null,
  urlFirstPage: null,
  urlNextPage: null,
  urlPrevPage: null,
  urlLastPage: null,
  urlPath: null,
  modalidadeSelecionado: undefined,
  erros: '',
  filter: null,
}

const getters = {
  GET_MODALIDADES : (state) => state.modalidades,
  GET_URL_PATH : (state) => state.urlPath,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  MODALIDADE_SELECTED : (state, { modalidade }) => {
    state.modalidadeSelecionado = Object.assign({}, modalidade)
  },

  SET_MODALIDADES : (state, { modalidades }) => {
    state.modalidades = JSON.parse(JSON.stringify(modalidades))
    state.urlFirstPage = modalidades.first_page_url
    state.urlPrevPage = modalidades.prev_page_url
    state.urlPrevPage = modalidades.prev_page_url
    state.urlLastPage = modalidades.last_page_url
    state.urlPath = modalidades.path
    state.currentPage = modalidades.current_page
  },

  SET_FILTER: (state, filter) => {
    state.filter = filter
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.modalidadeSelecionado = undefined,

}

const actions = {

  GET_MODALIDADES : async ({ commit, state }) => {
      commit('SET_MODALIDADES', { modalidades : []})
      commit('ERASE_ERROS')
      await ModalidadeService.getModalidades(state.filter)
      .then(response => {
        if (response.data.status) {
          commit('SET_MODALIDADES', { modalidades : response.data.modalidades })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      })
  },

  PAGINATE_MODALIDADES : async ({ commit }, url) => {
    commit('ERASE_ERROS')
    await ModalidadeService.getPagination(url)
    .then(response => {
      if (response.data.status) {
        commit('SET_MODALIDADES', { modalidades : response.data.modalidades })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })
  },

  GET_MODALIDADE : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await ModalidadeService.getModalidade(id)
    .then(response => {
      if (response.data.status) {
        commit('MODALIDADE_SELECTED', { modalidade : response.data.modalidade })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })

  },
  
  STORE_MODALIDADE : async ({ commit, dispatch }, modalidade) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!modalidade.id || !(modalidade.id > 0)) { 
        var response = await ModalidadeService.postModalidade(modalidade)
      } else {
        var response = await ModalidadeService.putModalidade(modalidade.id, modalidade)
      }

      if (response.data.status) {
        commit('MODALIDADE_SELECTED', { modalidade : response.data.modalidade })
        if (state.urlPrevPage || state.urlNextPage) {
          await dispatch('PAGINATE_MODALIDADES', `${state.urlPath}?page=${state.currentPage}`)
        } else {
          await dispatch('GET_MODALIDADES')
        }

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_MODALIDADE : async ({ commit, dispatch }, modalidade) => {
    commit('ERASE_ERROS')
    try {
      var response = await ModalidadeService.deleteModalidade(modalidade.id)

      if (response.data.status) {
        await dispatch('GET_MODALIDADES')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  MODALIDADE_SELECTED : async ({dispatch, commit}, id) => { 
    if (id > 0) { 
      await dispatch('GET_MODALIDADE', id)
    } else {
      var obj = new modalidadeModel.modalidade()
      await commit('MODALIDADE_SELECTED', { modalidade: obj })
    }
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Modalidade/_store/index.js